module.exports = __webpack_public_path__ + "static/media/mashya_thumb_even.189579e4.webp";